export default __webpack_public_path__ + "static/media/ico-aws-principal-circle-solid.36b8c0d7.svg";